var map = {
	"./address_image.svg": 166,
	"./animated_ashutosh.png": 167,
	"./animated_logo.svg": 168,
	"./blogs_image.svg": 169,
	"./cba2016_paper.png": 170,
	"./cloud_infrastructure.svg": 171,
	"./codeInLogo.png": 172,
	"./contactMail.png": 173,
	"./coursera_logo.png": 174,
	"./data_science.svg": 175,
	"./deeplearning_ai_logo.png": 176,
	"./delhivery_logo.png": 177,
	"./developerActivity.svg": 178,
	"./dsc_logo.png": 179,
	"./education.svg": 180,
	"./experience.svg": 181,
	"./feelingProud.svg": 182,
	"./freecopy_logo.png": 183,
	"./fullstack.svg": 184,
	"./gcp_logo.png": 185,
	"./github_logo.png": 186,
	"./googleAssistant.jpg": 187,
	"./googleAssistant.svg": 188,
	"./google_logo.png": 189,
	"./ibm_logo.png": 190,
	"./iiitk_logo.png": 191,
	"./intel_logo.jpg": 192,
	"./iu_logo.png": 193,
	"./jcae2022_paper.gif": 194,
	"./jsFramework.svg": 195,
	"./legato_logo.png": 196,
	"./manOnTable.svg": 197,
	"./microsoft_logo.png": 198,
	"./mozilla_logo.png": 199,
	"./muffito_logo.png": 200,
	"./nextuLogo.jpg": 201,
	"./nptel_logo.png": 202,
	"./portfolio.gif": 203,
	"./programmer.svg": 204,
	"./projects_image.svg": 205,
	"./pwa.png": 206,
	"./saayaHealthLogo.png": 207,
	"./stanford_logo.png": 208,
	"./talksCardBack.svg": 209,
	"./talksCardBackAlt.svg": 210,
	"./tiktok_logo.png": 211,
	"./ui_ux_design.svg": 212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;